<template>
  <div :class="[bemClass(), { 'is-active': isActive }]">

    <div :class="bemClass('header')">
      <slot name="activator" :open="open" :close="close" :toggle="toggle">
      </slot>
    </div>

    <div :class="bemClass('content')" ref="contentElement" style="overflow: hidden;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import activator from '../../compositions/activator'
import useBem from '../../compositions/bem'
import { onMounted, onUpdated, ref, toRefs } from 'vue'

export default {
  name: 'SelExpansion',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { isActive, modifier } = toRefs(props)
    const contentElement = ref(null)

    onMounted(() => {
      contentElement.value.style.height = 0
    })

    /**
     * Whenever content inside slot might change, triggering a re-render, we need to
     * recalculate the height so that new elements don't get clipped, or removed elements
     * don't leave gaps.
     */
    onUpdated(() => {
      const el = contentElement.value
      const currentHeight = parseInt(el.style.height) || 0
      let newHeight = el.scrollHeight + 'px'

      if (isActive.value) {
        // if already expanded, then we need to find out natural height
        // and set the new height
        if (currentHeight !== 0) {
          // set inline style height back to null to get natural scroll height
          el.style.height = null
          newHeight = el.scrollHeight + 'px'

          // set the element's height back to current height so that in the next
          // frame, transition happens as expected
          el.style.height = currentHeight + 'px'
        }
      } else {
        newHeight = 0
      }

      requestAnimationFrame(() => {
        el.style.height = newHeight
      })
    })

    const { bemClass } = useBem('sel-expansion', modifier)

    return {
      contentElement,
      bemClass,
      ...activator(props, { emit })
    }
  }
}
</script>

<style scoped>
.sel-expansion__content {
  transition: height .3s ease-out;
}
</style>
